module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-01.65c5aa73.jpg";